export class Breadcrumb {
	constructor(public label: string, public route: string) { }
}
